import React, { useState } from 'react';
import List from '@mui/material/List';
import { ListItemButton } from '@mui/material';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import Collapse from '@mui/material/Collapse';
import { LzTNavItem, LzTNavItems } from '../../layout/Navigation/types';
import { lzFGetCurrentRoute, lzFGetCurrentRouteEquivOfKeyBreadcrumb } from '@lz/services/Utils';

export interface LzPModernWithLeftNavTemplateDrawerList {
  level: number;
  parentKeyBreadcrumb: string;
  navItems: LzTNavItems;
  onItemClick: (
    item: LzTNavItem,
    event: React.MouseEvent<HTMLElement, MouseEvent>
  ) => void;
}

const LzXModernWithLeftNavTemplateDrawerList = (
  props: LzPModernWithLeftNavTemplateDrawerList
) => {
  const currRoute = lzFGetCurrentRoute();
  const currRouteEquivOfKeyBreadcrumb =
    lzFGetCurrentRouteEquivOfKeyBreadcrumb();
  const parentKeyBreadcrumbPrefix =
    props.parentKeyBreadcrumb + ('' === props.parentKeyBreadcrumb ? '' : '.');

  const selDex = props.navItems.findIndex(
    (navItem) =>
      0 ===
      currRouteEquivOfKeyBreadcrumb.indexOf(
        parentKeyBreadcrumbPrefix + navItem.key
      )
  );
  const [navLevelDex, setNavLevelDex] = useState(selDex);

  // console.log('NavItems:', props.navItems, 'ParentKeyBC:', parentKeyBreadcrumbPrefix, 'RouteKeyBC:', currRouteEquivOfKeyBreadcrumb, 'SelDex:', selDex);

  const listItemStyle = {
    marginLeft: '-' + props.level * 16 + 'px',
    paddingLeft: (props.level + 1) * 16 + 'px',
  };

  // console.log('ND Level', props.level, listItemStyle);

  return (
    <List disablePadding>
      {props.navItems.map((obj, dex) => (
        <React.Fragment key={'drawer-nav-' + dex}>
          {obj.children ? (
            <React.Fragment>
              <ListItemButton
                onClick={() => setNavLevelDex(dex)}
                style={listItemStyle}
              >
                {dex === navLevelDex ? (
                  <ArrowDropDownIcon />
                ) : (
                  <ArrowRightIcon />
                )}
                <ListItemIcon>{obj.icon}</ListItemIcon>
                <ListItemText>{obj.title}</ListItemText>
              </ListItemButton>
              <Collapse in={dex === navLevelDex} timeout='auto' unmountOnExit>
                <LzXModernWithLeftNavTemplateDrawerList
                  level={props.level + 1}
                  parentKeyBreadcrumb={parentKeyBreadcrumbPrefix + obj.key}
                  navItems={obj.children}
                  onItemClick={props.onItemClick}
                />
              </Collapse>
            </React.Fragment>
          ) : (
            <ListItemButton
              selected={currRoute === obj.route}
              onClick={(event) => props.onItemClick(obj, event)}
              style={listItemStyle}
            >
              <div className='icons-placeholder'></div>
              <ListItemIcon>{obj.icon}</ListItemIcon>
              <ListItemText>{obj.title}</ListItemText>
            </ListItemButton>
          )}
        </React.Fragment>
      ))}
    </List>
  );
};

export default LzXModernWithLeftNavTemplateDrawerList;
